<template>
  <vx-card>
    <!-- POST HEADER -->
    <div class="post-header flex justify-between mb-4">
      <div class="flex items-center">
        <div>
          <vs-avatar class="m-0" :src="post.user.image" icon-pack="feather" size="45px" @click="viewProfile(post.user.id)"></vs-avatar>
        </div>
        <div class="ml-4">
          <h6 class="text-dark cursor-pointer" @click="viewProfile(post.user.id)">{{ post.user.name }}</h6>
          <small>{{ post.created_at | ago }}</small>
        </div>
      </div>
      <div v-if="isTeacher || post.user.id === user.id" class="flex">
        <vs-dropdown vs-drop-right vs-custom-content class="effect-dropdown cursor-pointer" vs-trigger-click>
          <feather-icon icon="MoreHorizontalIcon" />

          <vs-dropdown-menu>
            <vs-dropdown-item @click="deletePost">
              <feather-icon icon="TrashIcon" svgClasses="w-4 h-4"></feather-icon>
              <span class="ml-2">حذف</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <!-- POST CONTENT -->
    <div class="post-content" >
      <div class="mx-5 leading-loose whitespace-pre-wrap break-words" dir="auto">
        <p class="inline" v-html="postBody"></p>
        <span v-if="isSeeMoreActive" class="text-primary cursor-pointer hover:underline whitespace-no-wrap font-bold" @click="seeMore = true"> عرض المزيد</span>
      </div>
      <div v-if="post.type === 'poll'" class="poll my-6">
        <div v-for="(choice, index) in post.polls" :key="index" class="position-relative my-5">
          <div class="flex justify-between items-center">
            <p class="flex items-center truncate">
              <vs-radio @change="updateChoice" v-model="currentChoice" color="primary" :vs-value="choice.id"></vs-radio>
              <span class="ml-2 truncate" :title="choice.title">{{choice.title}}</span>
            </p>
            <span>{{choicePercent(choice.votes_num)}}%</span>
          </div>
          <vs-progress :height="10"
                       :percent="choicePercent(choice.votes_num)"
                       color="primary" />
        </div>
        <p class="my-5">عدد الاصوات : {{totalVotes}}</p>
      </div>
       <file v-else-if="post.type === 'file'" class=" my-6"
             :title="`تنزيل ${post.files[0].filename}`"
             :name="post.files[0].filename"
             :size="post.files[0].size"
             :path="post.files[0].path" />
      <div v-else-if="post.type === 'image'" class="post-media-container mb-6 mt-4">
        <ul class="flex">
          <li class="h-100 rounded overflow-hidden m-1 w-full">
            <img style="height: inherit; object-fit: cover" class="m-auto w-full cursor-pointer"
                 :src="post.images[0].full_path"
                 alt="user-upload"
                 @click="viewImage(post.images[0].full_path)">
          </li>
        </ul>
      </div>
      <div v-else-if="post.type === 'video'" class="post-media-container mb-6 mt-4">
        <video-player ref="videoPlayer" class="media-video-player" @play="onPlayerPlay($event)" :options="videoSettings" v-once />
      </div>
    </div>


    <!-- POST Comments -->
    <div>
      <vx-divider position="near-right">
        <div class="flex items-center"> <span>{{ post.comments.length }}</span> <feather-icon class="ml-2" icon="MessageCircleIcon" svgClasses="h-5 w-5"></feather-icon> </div>
      </vx-divider>
      <div class="comments-container mt-4">
        <div v-if="commentsLength > 4 && !viewAllComments" class="ml-5 mb-4 font-bold text-primary hover:underline cursor-pointer" @click="viewAllComments = true">
            <span>عرض التعليقات السابقة</span>
        </div>
        <ul class="user-comments-list">
          <post-comment v-for="(comment, index) in comments" :key="index"
                        :comment="comment" @deleted="removeComment" @viewImage="viewImage"
                        class="flex items-start my-5" />
        </ul>
      </div>
      <vs-divider class="my-5" v-if="post.comments.length > 0"/>
      <div>
        <div class="flex relative items-end">
          <textarea-autosize :dir="commentBox.text ? 'auto' : 'rtl'" @keypress.enter.exact.prevent="addComment(post)" rows="1" class="rounded-xl w-full pl-3 pr-20" placeholder="قم بكتابة تعليق..." v-model="commentBox.text" />
          <div class="flex absolute right-0 bottom-0 mb-2px items-center mr-1">
            <feather-icon icon="ImageIcon" class="mr-2" svg-classes="h-6 w-6 cursor-pointer hover:text-primary" @click="$refs.commentImageInput.click()"/>
            <vs-button icon-pack="feather" radius icon="icon-send" @click="addComment(post)"/>
          </div>
          <input @change="getCommentImage($event)" ref="commentImageInput" accept="image/*" type="file" hidden>
        </div>
        <div v-if="commentBox.image" class="relative cursor-pointer sm:max-w-xs max-w-full">
          <img class="mt-2 rounded-xl sm:max-w-xs max-w-full"
               :src="commentBox.image"
               @click="viewImage(commentBox.image)" alt="">
          <vs-button @click="commentBox.image = commentBox.imageFile = null"
                     class="absolute top-0 right-0 mt-2 mr-2" size="small" radius
                     icon-pack="feather" icon="icon-x" color="danger"/>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
    import postsAPI from "@/api/postsAPI"
    import commentsAPI from "@/api/commentsAPI"
    import PostComment from "./PostComment"

    import { videoPlayer } from 'vue-video-player'
    import '@/assets/css/video-js.min.css'

    export default {
        name: "Post.vue",
        components: {
          PostComment,
          videoPlayer
        },
        props: {
            post: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                viewAllComments: false,
                seeMore: false,
                course_id: this.$route.params.course_id,
                currentChoice: 0,
                prevChoice: null,
                commentBox: {text: '', image: null},
            }
        },
        watch: {
            currentChoice(newVal, oldVal){
                this.prevChoice = oldVal

                if(oldVal === 0 && this.post.polls.find(choice => choice.is_checked)) return

                this.post.polls.forEach(choice => {
                    if(oldVal !== 0 && choice.id === oldVal){
                        choice.votes_num--
                        choice.is_checked = false
                    } else if(choice.id === newVal){
                        choice.votes_num++
                        choice.is_checked = true
                    }
                })
            }
        },
        computed: {
            postBodyMaxLength() {
              let max = 250
              if(this.post.text) {
                const links = this.post.text.match(/([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi) || []
                links.forEach(link => {
                  const index = this.post.text.indexOf(link)
                  if(index < max && index + link.length > max) {
                    max = index + link.length
                  }
                })
              }
              return max
            },
            isSeeMoreActive() {
              return !this.seeMore && this.post.text && this.post.text.length > 300 && this.postBodyMaxLength < this.post.text.length
            },
            postBody() {
                if(this.isSeeMoreActive) {
                  return this.postFilter(this.post.text.substring(0, this.postBodyMaxLength) + '...')
                } else {
                  return this.postFilter(this.post.text)
                }
            },
            commentsLength() {
                return this.post.comments.length
            },
            comments() {
                if(this.commentsLength > 4 && !this.viewAllComments) {
                  return this.post.comments.slice(this.commentsLength - 4, this.commentsLength)
                } else {
                  return this.post.comments
                }
            },
            videoSettings () {
                return {
                    height: '360',
                    fluid: true,
                    autoplay: false,
                    muted: false,
                    language: 'ar',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: {
                        type: `video/${this.videoType}`,
                        src: process.env.VUE_APP_API_ENDPOINT+'/file/v?path='+this.post.videos[0].path
                    }
                }
            },
            videoType() {
                const video = this.post.videos[0].path
                return video.substring(video.lastIndexOf('.')+1, video.length)
            },
            totalVotes(){
                return this.post.polls.reduce((total, choice) => total + choice.votes_num, 0)
            },
            choicePercent(){
                return (choiceVote) => {
                    if(this.totalVotes === 0) return 0
                    return Math.round((choiceVote / this.totalVotes) * 100)
                }
            },
        },
        methods: {
            postFilter(text){
                return (text || "").replace(/([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi, (match, space, url) => {
                        let hyperlink = url
                        if (!hyperlink.match('^https?://')) hyperlink = 'http://' + hyperlink
                        return space + '<a href="' + hyperlink + '" target="_blank">' + url + '</a>'
                    })
            },
            onPlayerPlay($event) {

                // Pause all others video when play one
                const videos = document.getElementsByClassName('video-js')
                for (let i = 0; i<videos.length; i++){
                    if(videos.item(i).id !== $event.id_){
                        videos.item(i).firstChild.pause()
                    }
                }
            },
            deletePost(){
              const message = 'هل انت متأكد بأنك تريد حذف النقاش؟'
              this.$confirmAlert(null, message, () => {
                postsAPI.delete(this.post.id).then(response => {
                  this.$emit('deleted')
                  this.$notifySuccess(response.successMessage)
                }).catch(error => this.$notifyError(error.statusMessage))
              })
            },
            addComment(post){
                if(this.commentBox.text.trim() === '' && this.commentBox.image === null) return

                let comment = {
                    user: this.user,
                    time: this.$store.state.date,
                    body: this.commentBox.text,
                    image: this.commentBox.imageFile,
                }

                let commentData = new FormData()
                commentData.append('post_id', post.id)
                commentData.append('body', comment.body)
                commentData.append('image', comment.image)

                commentsAPI.create(commentData)
                    .then( ({data}) => {
                        comment.id = data.id
                        comment.image = data.path
                        post.comments.push(comment)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))

                this.commentBox.text = ''
                this.commentBox.image = null
            },
            removeComment(id){
              const index = this.post.comments.findIndex(comment => comment.id === id)
              this.$delete(this.post.comments, index)
            },
            getCommentImage(event){
                let $this = this;
                let image = new Image();
                let file = event.target.files[0];
                this.commentBox.imageFile = file
                let reader  = new FileReader();
                if (/image.*/.test(file.type)) {
                    reader.onload = function(e){
                        image.src = e.target.result;
                        image.onload = function(){
                            $this.commentBox.image = image.src
                        }
                    };
                    reader.readAsDataURL(file);
                }
                let input = event.target
                input.type = 'text'
                input.type = 'file'
            },
            updateChoice(){
                postsAPI.updatePoll(this.post.id, this.currentChoice)
                    .catch(() => this.currentChoice = this.prevChoice)
            },
            downloadFile(){
                let filename = this.post.files[0].filename;
                postsAPI.downloadFile(this.post.id, filename)
                    .catch(error => this.$notifyError(error.statusMessage))
            },
            viewImage(src){
                this.$emit('viewImage', src)
            },
        },
        mounted() {
            this.post.type = this.post.type.toLowerCase()
            if (this.post.type === 'poll') {
                this.post.polls.forEach((choice) => {
                    if (choice.is_checked)
                        this.currentChoice = choice.id
                })
            }
        }
    }
</script>

<style lang="scss">
  .poll {
    .choice-title {
      position: absolute;
      z-index: 999;
      margin: 5px 20px;
      min-height: 30px;
      font-weight: 600;
    }

    .choice-percent {
      position: absolute;
      z-index: 999;
      margin: 5px -50px;
      min-height: 30px;
      width: 40px;
      text-align: center;
      font-weight: 600;
    }

    .choice-progress {
      width: 90% !important;
    }

    .choice-btn {
      position: absolute;
      height: 30px;
      margin: auto 20px;
    }
  }
  .image-holder {
    height: 350px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
</style>
